import { render } from "./BackgroundSize.vue?vue&type=template&id=7aef2772&scoped=true&ts=true"
import script from "./BackgroundSize.vue?vue&type=script&lang=ts"
export * from "./BackgroundSize.vue?vue&type=script&lang=ts"

import "./BackgroundSize.vue?vue&type=style&index=0&id=7aef2772&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aef2772"]])

export default __exports__